import React from 'react';
import {
    TEMPLATE_ID_BANNER_AD,
    TEMPLATE_ID_EMAIL,
    TEMPLATE_ID_SMS,
    TEMPLATE_ID_SALES_REP,
    TEMPLATE_ID_CUSTOM_MEDIA,
    TEMPLATE_ID_VIDEO
} from "../../../constants";
import {
    BannerAdCampaign,
    EmailCampaign,
    SMSCampaign,
    SalesRepCampaign,
    CustomMedia,
} from './campaignForms';


const TEMPLATE_COMPONENT_MAP = {
    [TEMPLATE_ID_BANNER_AD]: BannerAdCampaign,
    [TEMPLATE_ID_EMAIL]: EmailCampaign,
    [TEMPLATE_ID_SMS]: SMSCampaign,
    [TEMPLATE_ID_SALES_REP]: SalesRepCampaign,
    [TEMPLATE_ID_CUSTOM_MEDIA]: CustomMedia,
};

const CampaignMessageForm = (props) => {
    const { campaignId, templateId, handleClose, handleUpdateCampaign } = props;

    const FormComponent = TEMPLATE_COMPONENT_MAP[templateId];
    return (<FormComponent campaignId={campaignId} handleClose={handleClose} handleUpdateCampaign={handleUpdateCampaign} />)
}

CampaignMessageForm.defaultProps = {
    templateId: 1,
    handleClose: () => {},
    handleUpdateCampaign: () => {},
};

export default CampaignMessageForm;